/* eslint-disable react-hooks/exhaustive-deps */
import {RootState, useAppDispatch, useAppSelector} from "../../../../state/state.tsx";
import besakshamLogo from "../../../../assets/HosakshamHorizontal.png"
import OTPForm from "./Components/Otplogin.tsx";
import PhoneLogin from "./Components/PhoneLogin.tsx";
import React, {useEffect, useState} from "react";
import {auth, db, SECRETS_ENV} from "../../../../Config/firebase.ts";
import {signInWithCustomToken} from "firebase/auth";
import { actions as userV2Actions } from "../../../../state/UserStatesV2/userSliceV2.ts";
import {useNavigate} from "react-router-dom";
import {collection, getDocs, query, where, doc, setDoc} from "firebase/firestore";
import PageNotFound from "../ErrorPages/PageNotFound.tsx";
import loginPageImage from "../../../../assets/images/loginimg.png"
import { UserStateV2 } from "../../types/UserStateV2.ts";
import { verifyCaptchaToken, sendOtpApi, verifyOtpApi } from "../../../../api/otpApi.ts";
import toast from 'react-hot-toast';
import { getCustomBrandingSubdomainFromHost } from "../../../../utils/customDomainSubdomain.ts";

function hostRequiresCustomBrandingFetch(host: string): boolean {
    const potentialSubDomain = getCustomBrandingSubdomainFromHost(host);
    if (!potentialSubDomain || potentialSubDomain.includes("localhost")) {
        return false;
    }
    return !SECRETS_ENV.EXCLUDED_DOMAINS.includes(potentialSubDomain);
}

// TypeScript declaration for window.turnstile
declare global {
    interface Window {
        turnstile?: {
            render: (selector: string, options: any) => string;
            remove: (widgetId: string) => void;
            reset: (widgetId: string) => void;
        };
    }
}

export default function Login() {

    const Dispatch = useAppDispatch();
    const userSlice = useAppSelector((state: RootState) => state.userSliceV2)   
    const authState = (userSlice.data as UserStateV2)?.isAuthenticated
    const loading = userSlice.data?.loading

    const [phoneNumber, setPhoneNumberState] = useState<string>("")
    const [isPhoneNumberSubmitted, setIsPhoneNumberSubmitted] = useState<boolean>(false)
    const [InvalidOtpError, setInvalidOtpError] = useState<boolean>(false)
    const navigate = useNavigate();
    const [otpFormReady, setOtpFormReady] = useState(false);
    const [subDomain, setSubDomain] = useState<string>("")
    const [customBrandingImage, setCustomBrandingImage] = useState<string>("")
    const [customLogo, setCustomLogo] = useState<string>("")
    const [customBrandingDocLoaded, setCustomBrandingDocLoaded] = useState<boolean>(
        typeof window === "undefined" ? true : !hostRequiresCustomBrandingFetch(window.location.host)
    )
    const [customLogoImageReady, setCustomLogoImageReady] = useState<boolean>(false)
    const [isSubDomainError, setIsSubDomainError] = useState<boolean>(false)
    const [isOtpSubmitLoading, setIsOtpSubmitLoading] = useState<boolean>(false)
    const [status, setStatus] = useState<string>("")
    
    // Turnstile states
    const [turnstileToken, setTurnstileToken] = useState<string | null>(null);
    const turnstileRef = React.useRef<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    
    // SMS fallback states
    const [smsAttempted, setSmsAttempted] = useState<boolean>(false);
    const [resendTimer, setResendTimer] = useState<number>(0);
    const [canResendSms, setCanResendSms] = useState<boolean>(false);
    const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
    const [otpDeliveryMethod, setOtpDeliveryMethod] = useState<"whatsapp" | "sms" | null>(null);
    
    // Check if Turnstile should be enabled based on subdomain
    const shouldUseTurnstile = React.useMemo(() => {
        const host = window.location.host;
        const firstPart = host.split(".")[0];
        // Only use Turnstile for "app" or "dev" subdomains
        const shouldUse = firstPart === 'app' ;
        console.log('🔐 Turnstile enabled:', shouldUse, '(subdomain:', firstPart + ')');
        return shouldUse;
    }, []);

    const isCoachHost = React.useMemo(() => {
        const hostname = window.location.host.split(":")[0];
        return hostname.split(".")[0] === "coach";
    }, []);

    // Check if user is available and retrieve information from firestore
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
             
            if (user) {
            
                Dispatch(userV2Actions.setPhoneNumber(user.phoneNumber!))
       
                Dispatch(userV2Actions.setOtherDetails({ uid: user.uid }));
           
                Dispatch(userV2Actions.checkUserInFirestore(user.uid));

                Dispatch(userV2Actions.setAuthenticated(true));

            }
           
        });

        return () => unsubscribe();
    }, [Dispatch]);

    // Cleanup Turnstile when component unmounts
    useEffect(() => {
        return () => {
            cleanupTurnstile();
        };
    }, []);

    // SMS resend timer effect
    useEffect(() => {
        if (resendTimer > 0) {
            const timerId = setInterval(() => {
                setResendTimer(prevTimer => prevTimer - 1);
            }, 1000);
            return () => clearInterval(timerId);
        } else if (smsAttempted) {
            setCanResendSms(true);
        }
    }, [resendTimer, smsAttempted]);

    useEffect(() => {
        setCustomLogoImageReady(false);
    }, [customLogo]);

    // Reset SMS state when going back to phone number screen
    useEffect(() => {
        if (!isPhoneNumberSubmitted) {
            setSmsAttempted(false);
            setResendTimer(0);
            setCanResendSms(false);
            setIsOtpSent(false);
            setOtpDeliveryMethod(null);
        }
    }, [isPhoneNumberSubmitted]);

    // Checking for auth status followed by required navigation
    useEffect(() => {
        console.log("came here -1", userSlice.data)
       if(loading){
        console.log("came here -1.1")
        return
       }
        if (authState === true && (userSlice.data as UserStateV2)?.display_name) {
            console.log("came here -2")
            navigate("/mydashboard")
            // cleanupTurnstile();
        } else if (authState === true) {
            console.log("came here -3")
            navigate("/fill-details")
            // cleanupTurnstile();
        }
    }, [authState, navigate, userSlice,loading])

    // Function to clean up Turnstile elements - isolated to prevent cross-origin errors
    const cleanupTurnstile = () => {

        // Store ref locally and clear immediately to prevent race conditions
        const widgetId = turnstileRef.current;
        turnstileRef.current = null;
        
        // Run cleanup asynchronously to not block Redux operations
        setTimeout(() => {
            try {
                if (widgetId && window.turnstile) {
                    try {
                        window.turnstile.remove(widgetId);
                    } catch (removeError) {
                        // Silently ignore cross-origin errors from iframe cleanup
                        console.warn('Turnstile widget removal skipped (possibly already removed)');
                    }
                }
                
                const turnstileContainer = document.getElementById('turnstile-container');
                if (turnstileContainer) {
                    try {
                        turnstileContainer.innerHTML = '';
                    } catch (domError) {
                        // Silently ignore DOM cleanup errors
                    }
                }
                
                console.log('🧹 Turnstile cleanup completed');
            } catch (error) {
                // Catch-all to ensure cleanup errors never propagate
                console.warn('Error during Turnstile cleanup (safely ignored):', error);
            }
        }, 0);
    };

    // Reset Turnstile widget - wrapped to prevent cross-origin errors
    const resetTurnstileWidget = () => {
        const widgetId = turnstileRef.current;
        setTurnstileToken(null);
        
        if (widgetId) {
            // Run async to prevent blocking and cross-origin issues
            setTimeout(() => {
                try {
                    window.turnstile?.reset(widgetId);
                    console.log('🔄 Turnstile widget reset');
                } catch (error) {
                    // Silently ignore cross-origin errors
                    console.warn('Turnstile reset skipped (safely ignored)');
                }
            }, 0);
        }
    };

    // Verify Turnstile token with backend
    const verifyCaptchaTokenHandler = async (token: string) => {
        try {
            console.log('🔐 Verifying Turnstile token with backend...');
            setStatus('Verifying security check...');
            
            const result = await verifyCaptchaToken(token);

            if (result.success) {
                console.log('✅ Turnstile token verified successfully by backend');
                setTurnstileToken(token);
                setStatus('Security verification complete');
                return true;
            } else {
                console.error('❌ Backend verification failed:', result);
                setTurnstileToken(null);
                setStatus(result.message || 'Security verification failed. Please try again.');
                resetTurnstileWidget();
                return false;
            }
        } catch (error: any) {
            console.error('❌ Error verifying captcha token:', error);
            setTurnstileToken(null);
            setStatus('Security verification failed. Please try again.');
            resetTurnstileWidget();
            return false;
        }
    };

    // Set up Turnstile widget (only if enabled for this subdomain)
    useEffect(() => {
        // Skip Turnstile setup if not enabled for this subdomain
        if (!shouldUseTurnstile) {
            console.log('⏭️ Skipping Turnstile setup - not required for this subdomain');
            setTurnstileToken('bypassed'); // Set a bypass token
            return;
        }

        if (isPhoneNumberSubmitted) return; // Don't render when OTP screen is shown

        let retryCount = 0;
        const maxRetries = 50; // Try for up to 5 seconds

        const setupTurnstile = () => {
            console.log('🔄 Attempting to setup Turnstile...', { retryCount });

            if (typeof window.turnstile === 'undefined') {
                retryCount++;
                if (retryCount < maxRetries) {
                    console.log('⏳ Turnstile not loaded yet, retrying...', retryCount);
                    setTimeout(setupTurnstile, 100);
                } else {
                    console.error('❌ Turnstile failed to load after max retries');
                }
                return;
            }

            const turnstileContainer = document.getElementById('turnstile-container');
            if (!turnstileContainer) {
                console.error('❌ Turnstile container not found');
                retryCount++;
                if (retryCount < maxRetries) {
                    setTimeout(setupTurnstile, 100);
                }
                return;
            }

            console.log('✅ Turnstile container found, rendering widget...');

            // Clear any existing widget
            if (turnstileRef.current) {
                const oldWidgetId = turnstileRef.current;
                turnstileRef.current = null;
                try {
                    window.turnstile.remove(oldWidgetId);
                    console.log('🗑️ Removed existing Turnstile widget');
                } catch (error) {
                    // Silently ignore cross-origin errors
                    console.warn('Existing widget removal skipped (safely ignored)');
                }
            }

            // Render the Turnstile widget
            try {
                turnstileRef.current = window.turnstile.render('#turnstile-container', {
                    sitekey: '0x4AAAAAAB_A5l1Vtd5DQ86O', // REPLACE WITH YOUR SITEKEY
                    callback: async (token: string) => {
                        console.log('✅ Turnstile Challenge Completed! Token received from Cloudflare');
                        await verifyCaptchaTokenHandler(token);
                    },
                    'error-callback': (error: any) => {
                        console.error('❌ Turnstile Error:', error);
                        setTurnstileToken(null);
                        setStatus('Security verification failed. Please try again.');
                    },
                    'expired-callback': () => {
                        console.warn('⏰ Turnstile Expired');
                        setTurnstileToken(null);
                        setStatus('Security verification expired. Please refresh.');
                    },
                    'timeout-callback': () => {
                        console.warn('⏱️ Turnstile Timeout');
                        setTurnstileToken(null);
                        setStatus('Security verification timed out. Please try again.');
                    },
                    theme: 'light',
                    size: 'normal'
                });
                console.log('✅ Turnstile widget rendered with ID:', turnstileRef.current);
            } catch (error) {
                console.error('❌ Error rendering Turnstile widget:', error);
            }
        };

        // Small delay to ensure DOM is ready
        const timer = setTimeout(setupTurnstile, 100);

        // Cleanup function
        return () => {
            clearTimeout(timer);
            // Store ref locally and clear immediately
            const widgetId = turnstileRef.current;
            turnstileRef.current = null;
            
            if (widgetId) {
                // Run async to prevent blocking and cross-origin issues
                setTimeout(() => {
                    try {
                        window.turnstile?.remove(widgetId);
                        console.log('🧹 Cleaned up Turnstile widget');
                    } catch (error) {
                        // Silently ignore - cross-origin errors are expected
                        console.warn('Turnstile cleanup skipped (safely ignored)');
                    }
                }, 0);
            }
        };
    }, [isPhoneNumberSubmitted, shouldUseTurnstile]); // Re-run if isPhoneNumberSubmitted or shouldUseTurnstile changes

    // Send OTP via API (alternate method with type support)
    const handleSendOtpAlternate = async (otpType: "whatsapp" | "sms" = "whatsapp") => {
        // Validate phone number
        if (!phoneNumber || phoneNumber.length < 10) {
            setStatus('Please enter a valid phone number');
            return;
        }

        // Validate Turnstile token only for initial send
        if (!isOtpSent && shouldUseTurnstile && !turnstileToken) {
            setStatus('Please complete the security verification');
            return;
        }

        setIsLoading(true);
        setStatus(`Sending OTP via ${otpType === 'sms' ? 'SMS' : 'WhatsApp'}...`);

        try {
            const sendingPhoneNumber: string = "+91" + phoneNumber;
            const tokenToSend = shouldUseTurnstile ? turnstileToken! : 'bypassed';
            
            console.log('📤 Sending OTP via', otpType, 'with Turnstile:', shouldUseTurnstile ? 'enabled' : 'bypassed');
            const result = await sendOtpApi(sendingPhoneNumber, tokenToSend, otpType);

            if (result.success) {
                setIsOtpSent(true);
                setOtpFormReady(true);
                setOtpDeliveryMethod(otpType);
                setStatus(`OTP sent successfully via ${otpType === 'sms' ? 'SMS' : 'WhatsApp'}!`);
                console.log('✅ OTP sent successfully to:', sendingPhoneNumber, 'via', otpType);
            } else {
                setStatus(result.message || 'Unable to send OTP. Please try again.');
                console.error('❌ OTP sending failed:', result.message);
            }
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Unable to send OTP. Please try again.';
            console.error('Error sending OTP:', error);
            setStatus(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    // Send OTP via API (initial WhatsApp send)
    async function onSubmitPhoneNumber(): Promise<void> {
        await handleSendOtpAlternate("whatsapp");
    }

    // Handler for sending OTP via SMS
    const handleSendViaSMS = async () => {
        // Only respect timer after first SMS attempt
        if (smsAttempted && !canResendSms) return;
        
        setSmsAttempted(true);
        setCanResendSms(false);
        setResendTimer(30);
        setInvalidOtpError(false);
        await handleSendOtpAlternate("sms");
    };

    // Verify OTP via API
    async function onVerifyOTP(OTP: string): Promise<void> {
        try {
            console.log("onVerifyOTP", OTP);
            
            setIsOtpSubmitLoading(true);
            setStatus('Verifying OTP...');
            setInvalidOtpError(false);

            const sendingPhoneNumber: string = "+91" + phoneNumber;
            const result = await verifyOtpApi(sendingPhoneNumber, OTP);

            if (!result.success || !result.customToken) {
                throw new Error(result.message || 'Invalid OTP');
            }

            // Sign in with the custom token (Firebase)
            const userCredential = await signInWithCustomToken(auth, result.customToken);
            
            setStatus('OTP verified successfully!');

            // Check if consumer exists in Firestore
            const consumerQuery = query(
                collection(db, 'ServiceConsumers'),
                where('phone_number', '==', sendingPhoneNumber)
            );
            const consumerSnap = await getDocs(consumerQuery);

            if (consumerSnap.empty) {
                // Create new consumer if doesn't exist
                const newDocRef = doc(collection(db, 'ServiceConsumers'));
                await setDoc(newDocRef, {
                    phone_number: sendingPhoneNumber,
                    display_name: '',
                    email: ''
                });
            }

            // Dispatch login action to Redux (using existing userV2Actions)
            Dispatch(userV2Actions.setPhoneNumber(sendingPhoneNumber));
            Dispatch(userV2Actions.setOtherDetails({ uid: userCredential.user.uid }));
            Dispatch(userV2Actions.checkUserInFirestore(userCredential.user.uid));
            Dispatch(userV2Actions.setAuthenticated(true));

            toast.success("Logged in successfully");
            
        } catch (error: any) {
            const errorMessage = error?.message || 'Invalid OTP. Please try again.';
            console.error('Error verifying OTP:', error);
            setStatus(errorMessage);
            setInvalidOtpError(true);
        } finally {
            setIsOtpSubmitLoading(false);
        }
    }


    // function onChangeOtpSubmitLoading(value:boolean){
    //     setIsOtpSubmitLoading(value)
    // }

    // ---------------- Subdomain config


    useEffect(() => {
        const host = window.location.host;
        const potentialSubDomain = getCustomBrandingSubdomainFromHost(host);
        if (potentialSubDomain?.includes("localhost")) {
            return;
        }

        if (potentialSubDomain && !SECRETS_ENV.EXCLUDED_DOMAINS.includes(potentialSubDomain)) {
            setSubDomain(potentialSubDomain);
        }
    }, []);

    useEffect(() => {
        if (subDomain) {
            retreiveDocsForSubdomain()
        }
    }, [retreiveDocsForSubdomain, subDomain]);


    async function retreiveDocsForSubdomain() {
        try {
            const subdomainQuery = query(collection(db, 'CustomBranding'), where('subdomain', '==', `${subDomain}.${SECRETS_ENV.DOMAIN}`));
            const querySnapshot = await getDocs(subdomainQuery);
            if (!querySnapshot.empty) {
                const firstDoc = querySnapshot.docs[0];
                const brandingImage = firstDoc.data().brandingImage;
                const customlogos = firstDoc.data().logo
                setCustomBrandingImage(brandingImage)
                setCustomLogo(typeof customlogos === "string" ? customlogos : "")
            } else {
                setIsSubDomainError(true)
            }
        } finally {
            setCustomBrandingDocLoaded(true)
        }
    }

    // Add body class for login page
    useEffect(() => {
        document.body.classList.add('login-page');
        
        return () => {
            document.body.classList.remove('login-page');
            // Cleanup on navigation
            setTimeout(() => {
                if (window.turnstile) {
                    cleanupTurnstile();
                }
            }, 1000);
        };
    }, []);

    if (isSubDomainError) {
        return <PageNotFound/>
    }

    return (
        <div className="login-container h-[100vh] max-h-[100vh] overflow-hidden w-[100vw] bg-white">
            <div className="h-full w-full flex">
                {/* Left Side - Promotional Image */}
                <div className="hidden lg:flex w-1/2 h-full bg-[#1341AE] items-start justify-start p-0">
                    <img 
                        alt="Promotional" 
                        className="h-full object-contain scale-110" 
                        src={customBrandingImage || loginPageImage}
                    />
                </div>

                {/* Right Side - Login Form */}
                <div className="w-full lg:w-1/2 flex items-center lg:justify-start lg:pl-16 p-4 sm:p-8">
                    <div className="w-full max-w-md">
                        <div className="flex flex-col items-center">
                            {/* Mobile-only image */}
                            <img 
                                alt="Promotional" 
                                className="lg:hidden w-full h-auto max-h-[200px]  object-contain rounded-xl shadow-md mb-8" 
                                src={customBrandingImage || loginPageImage}
                            />

                            <div className="w-full bg-white rounded-2xl shadow-lg p-4 sm:p-5">
                                <div className="flex justify-center mb-1 min-h-12 sm:min-h-14 lg:min-h-20 items-center">
                                    {!customBrandingDocLoaded ? (
                                        <div
                                            className="h-12 sm:h-14 lg:h-20 w-44 sm:w-52 bg-gray-100 animate-pulse rounded-md"
                                            aria-hidden
                                        />
                                    ) : customLogo ? (
                                        <>
                                            {!customLogoImageReady && (
                                                <div
                                                    className="h-12 sm:h-14 lg:h-20 w-44 sm:w-52 bg-gray-100 animate-pulse rounded-md"
                                                    aria-hidden
                                                />
                                            )}
                                            <img
                                                className={`h-12 sm:h-14 lg:h-20 ${customLogoImageReady ? "" : "hidden"}`}
                                                src={customLogo}
                                                alt="Logo"
                                                onLoad={() => setCustomLogoImageReady(true)}
                                                onError={() => {
                                                    setCustomLogo("");
                                                    setCustomLogoImageReady(true);
                                                }}
                                            />
                                        </>
                                    ) : (
                                        <img
                                            className="h-12 sm:h-14 lg:h-20"
                                            src={besakshamLogo}
                                            alt="Logo"
                                        />
                                    )}
                                </div>
                                
                                {isPhoneNumberSubmitted ? (
                                    <OTPForm 
                                        phoneNumber={phoneNumber} 
                                        onVerifyOTP={onVerifyOTP}
                                        setIsPhoneNumberSubmitted={setIsPhoneNumberSubmitted}
                                        setInvalidOtpError={setInvalidOtpError}
                                        InvalidOtpError={InvalidOtpError}
                                        onSubmitPhoneNumber={onSubmitPhoneNumber} 
                                        otpFormReady={otpFormReady}
                                        isOtpSubmitLoading={isOtpSubmitLoading}
                                        handleSendViaSMS={handleSendViaSMS}
                                        smsAttempted={smsAttempted}
                                        canResendSms={canResendSms}
                                        resendTimer={resendTimer}
                                        isLoading={isLoading}
                                        otpDeliveryMethod={otpDeliveryMethod}
                                    />
                                ) : (
                                    <PhoneLogin 
                                        onSubmitPhoneNumber={onSubmitPhoneNumber} 
                                        phoneNumber={phoneNumber}
                                        setPhoneNumberState={setPhoneNumberState}
                                        setIsPhoneNumberSubmitted={setIsPhoneNumberSubmitted}
                                        turnstileToken={turnstileToken}
                                        isLoading={isLoading}
                                        shouldUseTurnstile={shouldUseTurnstile}
                                    />
                                )}
                                
                                {/* Show status message */}
                                {status && !isPhoneNumberSubmitted && (
                                    <div className={`mt-3 p-3 rounded-lg ${
                                        status.includes('success') || status.includes('complete') 
                                            ? 'bg-green-50 border border-green-200' 
                                            : status.includes('failed') || status.includes('expired') || status.includes('error')
                                            ? 'bg-red-50 border border-red-200'
                                            : 'bg-blue-50 border border-blue-200'
                                    }`}>
                                        <p className={`text-sm ${
                                            status.includes('success') || status.includes('complete')
                                                ? 'text-green-800'
                                                : status.includes('failed') || status.includes('expired') || status.includes('error')
                                                ? 'text-red-800'
                                                : 'text-blue-800'
                                        }`}>
                                            {status}
                                        </p>
                                    </div>
                                )}
                                {!isCoachHost && (
                                    <div className="mt-4 text-center text-xs sm:text-sm text-gray-600 space-y-1">
                                        {/* <div className="flex flex-wrap items-center justify-center gap-1">
                                            <a href="https://www.hosaksham.com/privacy-policy" className="text-blue-600 underline">Privacy Policy</a>
                                            <span>|</span>
                                            <a href="https://www.hosaksham.com/terms-and-conditions" className="text-blue-600 underline">Terms & Conditions</a>
                                        </div> */}
                                        <div className="text-xs sm:text-sm text-gray-600">Discover more about us at <a href="https://www.hosaksham.com" className="text-blue-600 underline">Hosaksham.com</a></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!isCoachHost && (
                <div className="absolute bottom-2 sm:bottom-4 right-2 sm:right-4 text-[10px] sm:text-xs text-gray-500 px-2">
                    <p className="break-words max-w-[200px] sm:max-w-none">© {new Date().getFullYear()} EagleX SaS Makers Private Limited | All Rights Reserved</p>
                </div>
            )}
        </div>
    )
}
